import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { StoresFilterScreenProps } from 'home/stack/types'
import { cloneDeep, isEqual } from 'lodash'
import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react'
import { MultiSelectSettingView } from 'settings/screens/types/multi_select/view'
import { SettingValue } from 'settings/types'
import Spinner from 'shared/components/spinner'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderButton } from 'shared/header/header_button'
import { useHelperStores } from 'stores/queries/list'
import { useFiltersContext } from '../context'

export function StoresFilterScreen({
  route,
  navigation,
}: StoresFilterScreenProps) {
  const { theme } = useTheme()
  const storesQuery = useHelperStores()
  const [loading, setLoading] = useState<boolean>(false)
  const {
    currentFilters,
    setCurrentFiltersWithToggle,
    setCurrentSelectedPresetIndex,
  } = useFiltersContext()
  const [selectedStoreIds, setSelectedStoreIds] = useState(
    currentFilters['stores'].selectedIds
  )

  const storesFilter = currentFilters['stores']

  const [storeIds, setStoreIds] = useState(storesFilter?.values)

  const setStoresFilter = useCallback(() => {
    if (storesFilter && storeIds) {
      const newStoresFilter = {
        ...storesFilter,
        values: storeIds,
        selectedIds: selectedStoreIds,
      }

      const updatedFilters = cloneDeep(currentFilters)
      if (
        !isEqual(
          updatedFilters['stores'].selectedIds,
          newStoresFilter.selectedIds
        )
      ) {
        updatedFilters['stores'] = newStoresFilter
        setCurrentFiltersWithToggle(updatedFilters)
        setCurrentSelectedPresetIndex(undefined)
      }
    }
  }, [
    currentFilters,
    selectedStoreIds,
    setCurrentFiltersWithToggle,
    setCurrentSelectedPresetIndex,
    storeIds,
    storesFilter,
  ])

  useLayoutEffect(
    () =>
      showHeaderButton({
        navigation,
        theme,
        title: t('done'),
        onPress: async () => {
          setLoading(true)
          setStoresFilter()
          navigation.goBack()
        },
      }),
    [navigation, setStoresFilter, theme]
  )

  useEffect(() => {
    const stores = storesQuery.data?.stores
    if (stores && stores.length > 0) {
      const currentStoreIds: SettingValue[] = stores.map(store => {
        return {
          id: store.id,
          name: `${store.storeNumber} - ${store.name}`,
          locked: false,
        }
      })
      setStoreIds(currentStoreIds)
    }
  }, [storesQuery.data?.stores])
  return (
    <StatusBoundary
      isLoading={storesQuery.isLoading}
      error={storesQuery.error}
    >
      {loading ? (
        <Spinner />
      ) : (
        <MultiSelectSettingView
          selectedIds={selectedStoreIds as string[]}
          values={storeIds ?? []}
          onSelectValue={setSelectedStoreIds}
        />
      )}
    </StatusBoundary>
  )
}
